import { SVGProps } from 'react'

export const LineRestaurant = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={24}
		height={24}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M21 17a5 5 0 0 1 0-10m0 14a9 9 0 1 1 0-18M6 11v10M6 3v5M3.5 8h5M9 3v4.352c0 4.864-6 4.864-6 0V3"
			stroke="currentColor"
			strokeWidth={1.5}
			strokeLinecap="round"
		/>
	</svg>
)
